import { render, staticRenderFns } from "./hcrmhttj.vue?vue&type=template&id=bb25d072&scoped=true&"
import script from "./hcrmhttj.vue?vue&type=script&lang=js&"
export * from "./hcrmhttj.vue?vue&type=script&lang=js&"
import style0 from "./hcrmhttj.vue?vue&type=style&index=0&id=bb25d072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb25d072",
  null
  
)

export default component.exports